module.exports = __webpack_public_path__ + "img/lev-big.c634b12.svg";